export default __webpack_public_path__ + "static/media/Play-icon.71f57145.svg";